export const paths = {
  root: '/',
  app: '/app',
  appRoutes: {
    dashboard: '/app',
    profile: '/app/profile',
    account: '/app/account',
    barcode: '/app/barcode',
    store: '/app/store',
    support: '/app/support',
    loyaltyTerms: '/app/loyalty-terms',
    discount: (id: number | string) => `/app/discounts/${id}`,
    discountFilters: (id: number | string) => `/app/discounts/${id}/filters`,
    discountProduct: (id: number | string) => `/app/discounts/products/${id}`,
    promotions: '/app/promotions',
    promotion: (id: number | string) => `/app/promotions/${id}`,
    events: '/app/events',
    event: (id: number | string) => `/app/events/${id}`,
    surveys: '/app/surveys',
    survey: (id: number | string) => `/app/surveys/${id}`,
  },
  auth: {
    phone: '/auth/phone',
    confirm: '/auth/confirm',
    otp: '/auth/otp',
    register: '/auth/register',
  },
} as const;

export type AppPath =
  | typeof paths.root
  | typeof paths.app
  | (typeof paths.auth)[keyof typeof paths.auth]
  | (typeof paths.appRoutes)[keyof typeof paths.appRoutes];
